import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { FileUp, ClipboardType } from 'lucide-react';
import PdfUploadTab from './PdfUploadTab';
import PasteTextTab from './PasteTextTab';

type Category = { id: string; name: string };

interface Props {
  categories: Category[];
  onSuccess: () => void;
}

export default function ContentUploader({ categories, onSuccess }: Props) {
  return (
    <Tabs defaultValue="pdf">
      <TabsList className="mb-4 w-full grid grid-cols-2">
        <TabsTrigger value="pdf" className="flex items-center gap-2">
          <FileUp className="w-4 h-4" />
          Upload PDFs
        </TabsTrigger>
        <TabsTrigger value="paste" className="flex items-center gap-2">
          <ClipboardType className="w-4 h-4" />
          Paste Text
        </TabsTrigger>
      </TabsList>
      <TabsContent value="pdf">
        <PdfUploadTab categories={categories} onSuccess={onSuccess} />
      </TabsContent>
      <TabsContent value="paste">
        <PasteTextTab categories={categories} onSuccess={onSuccess} />
      </TabsContent>
    </Tabs>
  );
}
